import React from 'react';
import { Grid, List } from 'semantic-ui-react';

import InformationItem from '../InformationItem';

const PersonalInformation = ({ passenger, promoCode, onEmailClick }) => {
  const {
    passengerFirstName,
    passengerLastName,
    passengerPhone,
    passengerEmail,
    street,
    city,
    postCode,
    country
  } = passenger || {};
  const promo_code = promoCode || passenger.promoCode;
  return (
    <Grid.Column>
      <List>
        {(passengerFirstName || passengerLastName) && (
          <InformationItem
            icon='user'
            content={`${passengerFirstName} ${passengerLastName}`}
            info='PAX name'
          />
        )}
        <InformationItem
          icon='phone'
          content={passengerPhone}
          info='PAX telephone'
        />
        <InformationItem
          icon='mail'
          content={<a onClick={onEmailClick}>{passengerEmail}</a>}
          info='PAX mail'
        />
        <InformationItem
          icon='talk outline'
          content={passenger.passengerLanguage}
          info='PAX language'
        />
        <InformationItem
          icon='ticket'
          content={
            promo_code ? `${promo_code.code} ${promo_code.percentage}%` : ''
          }
          info='PAX widget code'
        />
        <InformationItem
          icon='comments'
          content={passenger.widgetCommentFromPax}
          info='PAX comment'
        />
        <InformationItem
          icon='travel'
          content={passenger.profession}
          info='PAX profession'
        />
        <InformationItem
          icon='intergender'
          content={passenger.gender}
          info='PAX gender'
        />
        <InformationItem
          icon='world'
          content={passenger.nationality}
          info='PAX nationality'
        />
        <InformationItem icon='tag' content={passenger.pnr} info='PAX pnr' />
        <InformationItem
          icon='birthday'
          content={passenger.dateOfBirth}
          info='PAX birthday'
        />
        {(street || city || postCode || country) && (
          <InformationItem
            icon='home'
            content={`${street} ${city} ${postCode} ${country}`}
            info='PAX address'
          />
        )}
      </List>
    </Grid.Column>
  );
};

export default PersonalInformation;



// WEBPACK FOOTER //
// ./src/component/PassengerView/PersonalInformation.js